export const PRECONNECT = 'PRECONNECT';
export const PRELOGIN = 'PRELOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_NOT_ALLOWED = 'LOGIN_NOT_ALLOWED';
export const DISCONNECT = 'DISCONNECT';
export const CLOSE = 'CLOSE';


// WEBPACK FOOTER //
// ./src/constants/general.js